<template>
  <modal :title="options.title" :is-open="true" :action-button="{ label: options.actionLabel }" @dismiss="closeModalForm(permalink)" @submit="$refs.form.submitForm()">
    <vue-form :options="{ permalink, params }" :is-modal="true" ref="form" @load="focusField()" @complete="closeModalForm(permalink)"></vue-form>
  </modal>
</template>

<script>
import { mapMutations } from 'vuex'
import Modal from '@/components/Modal'
import VueForm from '@/components/Form'

export default {
  name: 'ModalForm',
  components: {
    Modal,
    VueForm
  },
  props: {
    permalink: {
      type: String
    },
    params: {
      type: Object
    },
    options: {
      type: Object,
      default () {
        return {
          adminOptions: true,
          isNew: true,
          title: 'Modal Title',
          actionLabel: 'Submit'
        }
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    async focusField () {
      await this.$nextTick()
      if (this.$refs.form.$el.querySelectorAll('input[type=text]').length) {
        this.$refs.form.$el.querySelectorAll('input[type=text]')[0].focus()
      }
    },
    ...mapMutations([
      'closeModalForm'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalForm.vue